import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import pic1 from './pictures/crochet1.JPG';
import pic2 from './pictures/crochet2.JPG';
import pic3 from './pictures/crochet3.JPG';
import pic4 from './pictures/crochet4.JPG';
import pic5 from './pictures/crochet5.JPG';

const Crochet = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>COM^2 x WiC x Q++ Crochet Worskshop!</h2>
                    <p class="site-post-meta">February 21st, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    
                    Last Friday, WiC hosted a crochet workshop along with COM^2 and Q++! 🧶

                    <br></br>
                    <br></br>

                    Thank you so much to everyone who was able to attend! We had so much fun seeing lots of familiar faces along with new ones :) 

                    COM^2’s chair, Kianna, gave an amazing tutorial on how to crochet a tulip, and we really hope everyone was able to successfully create one 🌷An in-depth video tutorial should also have been sent to all attendees’ emails in case if you’d like to make more tulips in the future 💐

                    <br></br>
                    <br></br>

                    Check out: tinyurl.com/Allen-Crochet for crochet resources from the workshop!

                    <br></br>
                    <br></br>

                    </p>
                    <img src={pic1} alt="pic1 "/>
                    <img src={pic2} alt="pic2"/>
                    <img src={pic3} alt="pic3"/>
                    <img src={pic4} alt="pic4"/>
                    <img src={pic5} alt="pic5"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Crochet;
